import React from 'react';

const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

/** Margin on the Trade price vs unit cost (both ex VAT). Staff only. */
export function MarginCell({ product, tradePrice }) {
  const cost = product.unit_cost;
  const price = Number(tradePrice || 0);
  if (cost == null || price <= 0) {
    return <div className="h-8 flex items-center justify-end px-2 text-xs text-gray-400" data-testid={`pricing-margin-${product.id}`} title={cost == null ? 'No cost set — add one in the Cost column' : 'No Trade price yet'}>—</div>;
  }
  const profit = price - cost;
  const pct = (profit / price) * 100;
  const tone = pct < 20 ? 'text-rose-700' : pct < 35 ? 'text-amber-700' : 'text-emerald-700';
  const approved = Number(product.prices?.approved || 0);
  return (
    <div className={`h-8 min-w-[92px] flex flex-col items-end justify-center px-2 leading-tight whitespace-nowrap ${tone}`} data-testid={`pricing-margin-${product.id}`}
      title={`Trade ${gbp(price)} − cost ${gbp(cost)} = ${gbp(profit)} (${pct.toFixed(1)}%)${approved > 0 ? ` · Approved tier margin ${(((approved - cost) / approved) * 100).toFixed(0)}%` : ''}`}>
      <span className="text-sm font-bold tabular-nums">{gbp(profit)}</span>
      <span className="text-[10px] font-semibold opacity-80">{pct.toFixed(0)}% on Trade</span>
    </div>
  );
}

const USED_LABEL = { quote_tool: 'Quote tool', order_builder: 'Order builder', installer_orders: 'Orders', prodecor_orders: 'Orders', proepoxy_orders: 'Orders', customer_quotes: 'Quotes' };

export function UsedInTags({ usedIn }) {
  if (!usedIn?.length) return null;
  const labels = [...new Set(usedIn.map((u) => USED_LABEL[u] || u))];
  return (
    <span className="ml-2 inline-flex gap-1 align-middle">
      {labels.map((l) => <span key={l} className="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-sky-50 text-sky-800 border border-sky-100" data-testid="pricing-used-tag">{l}</span>)}
    </span>
  );
}
